export default __webpack_public_path__ + "static/media/schmoedown-point-system.711c0691.png";